import { merge } from 'lodash';

import type { EnvironmentVariables } from 'features/environment/constants';
import { env } from 'features/environment/constants';
import type {
  EnvironmentVariablesConfig,
  PostLoginEnvironmentVariablesConfig,
  PreLoginEnvironmentVariablesConfig,
} from 'features/environment/interfaces';

type EnvironmentVariablesConfigPatch =
  | EnvironmentVariablesConfig
  | PreLoginEnvironmentVariablesConfig
  | PostLoginEnvironmentVariablesConfig;

const createEnvConfig = (): EnvironmentVariables => merge({}, env);

export class EnvironmentService {
  public static envConfig: EnvironmentVariables = createEnvConfig();

  public static setConfig(config: EnvironmentVariablesConfigPatch) {
    merge(this.envConfig, config);

    if (env.isDevelopmentBuild) {
      merge(this.envConfig, createEnvConfig());
    }
  }
}

export const envConfig = EnvironmentService.envConfig;
